import React, { useState } from 'react';

import { alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import {
  DomainNameApprovalStatus,
  useUpdateDomainNameVerificationApprovalMutation,
} from '@dashboard/generated/wp/administrator';
import { Button, MenuItem, Stack, TextField } from '@mui/material';

type Props = {
  status: DomainNameApprovalStatus;
  id: string;
};
export default function ApproveButton({ id, status }: Props) {
  const [currentStatus, setCurrentStatus] = useState(status);
  const [update, { loading }] = useUpdateDomainNameVerificationApprovalMutation();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSubmit = async (ev: any) => {
    ev.preventDefault();
    await update({ variables: { id, approvalStatus: currentStatus } });
    alertSuccess('Status updated');
  };

  return (
    <Stack component="form" onSubmit={onSubmit} direction="row" spacing={1} alignContent="center">
      <TextField
        select
        fullWidth
        size="small"
        value={currentStatus}
        label="Status"
        onChange={(ev) => setCurrentStatus(ev.target.value as DomainNameApprovalStatus)}
      >
        <MenuItem value={DomainNameApprovalStatus.Pending}>Pending</MenuItem>
        <MenuItem value={DomainNameApprovalStatus.Requested}>Requested</MenuItem>
        <MenuItem value={DomainNameApprovalStatus.Approved}>Approved</MenuItem>
        <MenuItem value={DomainNameApprovalStatus.Rejected}>Rejected</MenuItem>
      </TextField>
      <Button variant="outlined" disabled={loading} type="submit">
        Save
      </Button>
    </Stack>
  );
}
